import { Injectable } from '@angular/core';
import { apiservice6 } from '../common/apiservice6';

@Injectable({
  providedIn: 'root',
})
export class service_methods6 {
  constructor(private apiservice: apiservice6) {}

  async _commonget(endpoint: string) {
    return await this.apiservice.GET(endpoint);
  }


  async menus_get(endpoint: string) {
    return await this.apiservice.GET(endpoint);
  }

  async parentmenu_get(endpoint: string) {
    return await this.apiservice.GET(endpoint);
  }
  async _commongetfile(endpoint: string) {
    return await this.apiservice.GETFILE(endpoint);
  }

  async _commonpost(endpoint: string, data: any) {
    return await this.apiservice.POST(endpoint, data);
  }
  async _commonpostform(endpoint: string, data: any) {
    return await this.apiservice.POSTFORM(endpoint, data);
  }
  async _commonput(endpoint: string, data: any) {
    return await this.apiservice.PUT(endpoint, data);
  }
  async _commondelete(endpoint: string) {
    return await this.apiservice.DELETE(endpoint);
  }

  
}
